var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'zul-button': true, 'disabled': _vm.disabled },attrs:{"disabled":_vm.disabled},on:{"click":_vm.click}},[(_vm.$slots.icon)?_c('span',{staticClass:"button-icon"},[_vm._t("icon")],2):_vm._e(),_c('span',{staticClass:"button-label"},[_vm._t("default")],2),_c('span',{staticClass:"button-sub"},[_vm._t("sub")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }